import { nl2br } from '@/utils/utils';
import { Model } from '@vuex-orm/core';

export default class Objekt extends Model {
  static entity = 'objekt';
  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {string} */
    this.msid;
    /** @type {number | null} */
    this.status;
    /** @type {string | null} */
    this.objektnummer;
    /** @type {string | null} */
    this.objektname;
    /** @type {string | null} */
    this.ort;
    /** @type {string | null} */
    this.plz;
    /** @type {string | null} */
    this.strasse;
    /** @type {string | null} */
    this.lageerreichbarkeit;
    /** @type {any} */
    this.standortbeschreibung;
    /** @type {any} */
    this.kontakte;
    /** @type {any} */
    this.erstelltam;
    /** @type {any} */
    this.geaendertam;
    /** @type {number | null} */
    this.geaendertvon;
    /** @type {boolean | null} */
    this.exportnachkomsis;
    /** @type {number | null} */
    this.koordinatentyp;
    /** @type {any} */
    this.grundstuecke;
    /** @type {number | null} */
    this.objektart;
    /** @type {number | null} */
    this.hallenhoehe;
    /** @type {string | null} */
    this.flaechenbezeichnung;
    /** @type {number | null} */
    this.flaecheinqm;
    /** @type {boolean | null} */
    this.istteilbar;
    /** @type {number | null} */
    this.kleinsteflaecheinqm;
    /** @type {boolean | null} */
    this.istkaufobjekt;
    /** @type {boolean | null} */
    this.istmietobjekt;
    /** @type {number | null} */
    this.kaufpreis;
    /** @type {number | null} */
    this.kaufpreisproqm;
    /** @type {number | null} */
    this.mietpreis;
    /** @type {number | null} */
    this.mietpreisproqm;
    /** @type {string | null} */
    this.detailbeschreibung;
    /** @type {string | null} */
    this.internebeschreibung;
    /** @type {number | null} */
    this.versionsnummer;
    /** @type {any} */
    this.widmungen;
    /** @type {any} */
    this.technischeinfrastruktur;
    /** @type {any} */
    this.verkehrsinfrastruktur;
    /** @type {any} */
    this.bilder;
    /** @type {any} */
    this.videos;
    /** @type {string | null} */
    this.pano2vr;
    /** @type {any} */
    this.geometry;
    /** @type {any} */
    this.id;
    /** @type {any} */
    this.polygon;
    /** @type {number | null} */
    this.owner;
    /** @type {any} */
    this.uebersetzung;
    /** @type {boolean | null} */
    this.istabgelaufen;
    /** @type {any} */
    this.ablaufdatum;

    // Not a persisted field: set on the client when deactivating an objekt and
    // consumed by the API (see api/rest.js), which strips it before storing.
    /** @type {string | undefined} */
    this.reason4deactivate;
  }

  static fields() {
    return {
      msid: this.string(''),
      status: this.number(0).nullable(),
      objektnummer: this.string('').nullable(),
      objektname: this.string('').nullable(),
      ort: this.string('').nullable(),
      plz: this.string('').nullable(),
      strasse: this.string('').nullable(),
      lageerreichbarkeit: this.string('').nullable(),
      standortbeschreibung: this.attr([]).nullable(),
      kontakte: this.attr(undefined).nullable(),
      erstelltam: this.attr(undefined).nullable(),
      geaendertam: this.attr(undefined).nullable(),
      geaendertvon: this.number(0).nullable(),
      exportnachkomsis: this.boolean(true).nullable(),
      koordinatentyp: this.number(0).nullable(),
      grundstuecke: this.attr([]).nullable(),
      objektart: this.number(180620000).nullable(),
      hallenhoehe: this.number(0).nullable(),
      flaechenbezeichnung: this.string('').nullable(),
      flaecheinqm: this.number(0).nullable(),
      istteilbar: this.boolean(false).nullable(),
      kleinsteflaecheinqm: this.number(0).nullable(),
      istkaufobjekt: this.boolean(true).nullable(),
      istmietobjekt: this.boolean(true).nullable(),
      kaufpreis: this.number(0).nullable(),
      kaufpreisproqm: this.number(0).nullable(),
      mietpreis: this.number(0).nullable(),
      mietpreisproqm: this.number(0).nullable(),
      detailbeschreibung: this.string('').nullable(),
      internebeschreibung: this.string('').nullable(),
      versionsnummer: this.number(0).nullable(),
      widmungen: this.attr([]).nullable(),
      technischeinfrastruktur: this.attr([]).nullable(),
      verkehrsinfrastruktur: this.attr([]).nullable(),
      bilder: this.attr([]).nullable(),
      videos: this.attr([]).nullable(),
      pano2vr: this.string('').nullable(),
      geometry: this.attr(undefined).nullable(),
      id: this.attr(undefined).nullable(),
      polygon: this.attr(undefined).nullable(),
      owner: this.number(0).nullable(),
      uebersetzung: this.attr({
        msid: '',
        objektname_en: '',
        detailbeschreibung_en: '',
        lageerreichbarkeit_en: ''
      }).nullable(),
      istabgelaufen: this.boolean(true).nullable(),
      ablaufdatum: this.attr(undefined).nullable()
    };
  }

  static beforeCreate(model) {
    model.detailbeschreibung = nl2br(model.detailbeschreibung);
  }
}
